<template>
  <div id="projets-bloc-fore">
    <Title :titlePage="titlePage" />
    <v-container fluid class="pa-4">
      <resultList
        :header="headerProjets"
        :items="projets"
        :nbResult="nbDisplay"
        :type="'projets'"
        @sort="sort"
        :totalItems="totalItems"
        :page="page"
        :canModif="canModif"
        height="calc(87vh - 130px)"
      />
      <div v-if="totalPages > 1" class="pagination-bar">
        <button class="page-btn" :disabled="page === 1" @click="page--">
          <v-icon small>mdi-chevron-left</v-icon>
        </button>
        <span class="page-info">Page {{ page }} / {{ totalPages }}</span>
        <button class="page-btn" :disabled="page === totalPages" @click="page++">
          <v-icon small>mdi-chevron-right</v-icon>
        </button>
      </div>
    </v-container>
  </div>
</template>

<script>
import Title from "@/components/shared/Title";
import ResultList from "@/components/shared/ResultList";
import api from "@/api/projet";

export default {
  name: "ProjetBlocFore",
  components: { Title, ResultList },
  data() {
    return {
      titlePage: "Projets bloc foré en cours",
      projets: [],
      totalItems: 0,
      totalPages: 0,
      column: "date_projet",
      order: "DESC",
      page: 1,
      nbDisplay: Number.parseInt(process.env.VUE_APP_NB_DISPLAY),
      canModif: 0,
      headerProjets: [
        { text: "CLIENT",               align: "center", sortable: true,  value: "Entreprise.raison_sociale" },
        { text: "NOM DU PROJET",        align: "center", sortable: true,  value: "nom_projet" },
        { text: "DATE",                 align: "center", sortable: true,  value: "date_projet" },
        { text: "QTÉ ANNUELLE",         align: "center", sortable: true,  value: "qte_annuelle" },
        { text: "DERNIÈRE ÉTAPE VALIDÉE", align: "center", sortable: false, value: "derniere_etape" },
        { text: "PROCHAINE ÉTAPE",        align: "center", sortable: false, value: "prochaine_etape" },
        { text: "ACTIONS",              align: "center", sortable: false, value: "actions_bloc_fores" },
      ],
    };
  },
  watch: {
    page() {
      this.getProjets();
    },
  },
  methods: {
    getProjets() {
      api.getProjetsBlocFore(
        process.env.VUE_APP_NB_DISPLAY,
        this.page - 1,
        this.column,
        this.order,
      ).then((res) => {
        this.projets = res.data.projets.rows;
        this.totalItems = res.data.projets.totalItems;
        this.totalPages = res.data.projets.totalPages;
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
      });
    },
    sort(sortEvent) {
      if (sortEvent.column !== undefined) {
        this.column = sortEvent.column;
        this.page = sortEvent.page;
      }
      if (sortEvent.order !== undefined) {
        this.order = sortEvent.order ? "ASC" : "DESC";
      }
      this.getProjets();
    },
    canModified() {
      const role = this.$store.state.AsUser.id_utilisateur === ''
        ? this.$store.state.user.id_role
        : this.$store.state.AsUser.id_role;
      if (role === 1) {
        this.canModif = 1;
      }
    },
  },
  created() {
    this.getProjets();
    this.canModified();
  },
};
</script>

<style scoped lang="scss">
#projets-bloc-fore {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 6px 0 2px;
}

.page-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  &:hover:not(:disabled) {
    background: #f0f0f0;
    border-color: #0b87ba;
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
}

.page-info {
  font-size: 0.82rem;
  color: #555;
  font-weight: 500;
  min-width: 90px;
  text-align: center;
}
</style>
